// @flow

import styled from "styled-components";
import colors from "@src/common/colors";

const NavigationWrapper = styled.div`
  display: flex;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 62px;
  overflow: hidden;
  background-color: ${colors.whiteGrey};
  border-top-style: solid;
  border-top-width: 1px;
  border-top-color: ${colors.mediumDarkGrey};
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
`;

export default NavigationWrapper;



// WEBPACK FOOTER //
// ./src/containers/Assessment/Navigation/components/index.js